module.exports = "/_next/static/images/9cf5dbc17b536bfbf127795675850ba4-guy-lg.jpg";